import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { HistoryPeriodEnumKeys } from '@libs/types';

export enum MarketplaceAssetsSortByEnum {
  CHANGE_ASC = 'CHANGE_ASC',
  CHANGE_DESC = 'CHANGE_DESC',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
}

export type MarketplaceAssetType = {
  code: string;
  iconUrl?: string;
  name: string;
  rate?: string;
  change?: string;
  isFavorite: boolean;
  marketCap?: string;
};
export type GetPopularMarketplaceAssetsResponse = {
  getPopularMarketplaceAssets: DefaultApiResponse<MarketplaceAssetType[]>;
};
export type MarketplaceAdditionalArgs = {
  changeRecord?: {
    period: HistoryPeriodEnumKeys;
    valueAssetCode: string;
  };
  rateRecord?: { valueAssetCode: string };
};
export const getPopularMarketplaceAssetsQuery: TypedDocumentNode<
  GetPopularMarketplaceAssetsResponse,
  DefaultArg & MarketplaceAdditionalArgs
> = gql`
  query GetPopularMarketplaceAssets(
    $record: MarketplaceAssetsListRecord!
    $changeRecord: AssetsRateChangeRecord!
    $rateRecord: AssetsRateChangeRecord!
  ) {
    getPopularMarketplaceAssets(record: $record) {
      code
      iconUrl
      change(record: $changeRecord)
      rate(record: $rateRecord)
      name
      marketCap
    }
  }
`;
